<template>
  <div class="order-billing-api">
    <div class="search-form">
      <Input
        v-model="params.orderNo"
        placeholder="请输入交易订单号"
      ></Input>
      <Input
        v-model="params.orderDetailNo"
        placeholder="请输入订单明细号"
      ></Input>
      <Input
        v-if="!isRedirect"
        v-model="params.cardNo"
        placeholder="请输入身份证号"
      ></Input>
      <DatePicker
        type="daterange"
        :value="defaultTime"
        placement="bottom-end"
        placeholder="核销起止时间"
        @on-change="onDateChange"
      ></DatePicker>
      <Input
        v-if="!isRedirect"
        v-model="params.applySubject"
        placeholder="团队名称"
      ></Input>
      <Input
        v-if="!applySubjectId"
        v-model="params.applySubjectId"
        placeholder="团号"
      ></Input>
      <!-- <Input
        v-model="params.saleDutyName"
        placeholder="开票主体"
      ></Input> -->
      <Select
        v-model="params.saleDutyName"
        placeholder="开票主体，支持模糊搜索"
        style="width: 300px"
        filterable
        clearable
        :remote-method="searchRemotesaleDuty"
        :loading="saleDutySearchLoading"
        @on-change="onRemoteSaleDutyChange"
      >
        <template v-for="(item, index) in saleDutyNameList">
          <Option
            :key="index"
            :value="item.saleDutyName"
          >
            {{ item.saleDutyName }}
          </Option>
        </template>
      </Select>
      <Button
        type="primary"
        @click="search"
      >
        查询
      </Button>
      <Button
        type="primary"
        :loading="btnLoading"
        @click="goInvoice"
      >
        开票 ({{ selectArray.length }})
      </Button>
      <Button
        v-if="!isRedirect"
        type="primary"
        @click="frozen"
      >
        冻结
      </Button>
      <Button
        v-if="!isRedirect"
        type="primary"
        @click="unFrozen"
      >
        解冻
      </Button>
      <Button
        type="success"
        style="margin-left: 10px;"
        @click="exportExcel"
      >
        导出
      </Button>
    </div>
    <Table
      border
      :columns="isRedirect?columns2:columns"
      :data="tableData"
      :loading="tableLoading"
      @on-select="onSelection"
      @on-select-all="onSelectAll"
      @on-select-cancel="onSelectCancel"
      @on-selection-change="onSelectionChange"
    ></Table>
    <div
      v-if="isRedirect"
      class="totalprice"
    >
      合计：可开票金额<span>{{ totalLeftAmount }}</span>元
    </div>
    <Page
      :total="total"
      show-sizer
      style="margin-top: 10px"
      @on-change="onChange"
      @on-page-size-change="onPageSizeChange"
    />

    <Modal
      v-model="modalFirst"
      title="电子发票开票"
      :loading="isLoading"
      @on-ok="onFirstOk('firstFormValidate')"
      @on-cancel="onFirstCancel"
    >
      <Form
        ref="firstFormValidate"
        :model="firstForm"
        :rules="firstRule"
        :label-width="140"
      >
        <FormItem
          label="开票主体："
          prop="paramId"
        >
          <Select
            v-model="firstForm.paramId"
            placeholder="请选择开票主体"
            @on-change="onBillingChange"
          >
            <Option
              v-for="(item, index) in BillingArray"
              :key="index"
              :value="item.id"
            >
              {{ item.saleDutyName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          label="税收分类编号："
          prop="rateId"
        >
          <Select
            v-model="firstForm.rateId"
            placeholder="请选择税收分类编号"
            @on-change="rateIdChange"
          >
            <Option
              v-for="(item, index) in TaxNumberArray"
              :key="index"
              :value="item.id"
            >
              {{ item.einCode }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          label="税率："
          prop="name"
        >
          {{ rateRow.rate || 0 }}%
          {{
            rateRow.freeRate === undefined || rateRow.freeRate === ''
              ? ''
              : `（${getRateType(rateRow.freeRate)}）`
          }}
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="modalSecond"
      title="电子发票开票"
    >
      <Form
        ref="secondFormValidate"
        :model="secondForm"
        :rules="secondRule"
        :label-width="140"
      >
        <FormItem
          label="抬头类型："
          prop="buyCategory"
        >
          <RadioGroup
            v-model="secondForm.buyCategory"
            @on-change="onBuyCategoryChange"
          >
            <Radio :label="0">
              企业
            </Radio>
            <Radio :label="1">
              个人/其他
            </Radio>
          </RadioGroup>
        </FormItem>
        <!-- 抬头类型为公司，并不处于禁用状态，且店铺开启搜索功能可用 -->
        <FormItem
          v-if="
            secondForm.buyCategory === 0 &&
              !disabledBuyDutyName &&
              !disabledBuyDutyNo &&
              showSearch
          "
          label="企业名称"
          prop="buyDutyName"
          :required="true"
        >
          <Select
            v-model="secondForm.buyDutyName"
            placeholder="输入4个字符以上，支持模糊搜索"
            style="width: 300px"
            :disabled="disabledBuyDutyName"
            filterable
            clearable
            :remote-method="searchRemote"
            :loading="searchLoading"
            @on-change="onRemoteChange"
          >
            <template v-for="(item, index) in buyDutyNameList">
              <Option
                :key="index"
                :value="item.enterpriseName"
              >
                {{ item.enterpriseName }}
              </Option>
            </template>
          </Select>
        </FormItem>
        <FormItem
          v-else
          :label="`${secondForm.buyCategory === 1 ? '抬头名称' : '企业名称'}：`"
          prop="buyDutyName"
          :required="true"
        >
          <Input
            v-model="secondForm.buyDutyName"
            placeholder="请输入名称"
            style="width: 300px"
            :disabled="disabledBuyDutyName"
            :filterable="secondForm.buyCategory === 0"
          />
        </FormItem>
        <FormItem
          v-if="secondForm.buyCategory === 0"
          label="企业税号："
          prop="buyDutyNo"
          :required="true"
        >
          <Input
            v-model="secondForm.buyDutyNo"
            placeholder="请输入企业税号"
            style="width: 300px"
            :disabled="disabledBuyDutyNo"
          />
        </FormItem>
        <FormItem
          label="开票金额："
          prop="leftAmount"
        >
          <Input
            v-model="secondForm.leftAmount"
            placeholder="请输入开票金额"
            :disabled="selectArray.length > 1"
            style="width: 300px"
          />
        </FormItem>
        <FormItem
          label="手机号码："
          prop="receiveMobile"
          :required="true"
        >
          <Input
            v-model="secondForm.receiveMobile"
            placeholder="请输入手机号码"
            style="width: 300px"
          />
        </FormItem>
        <FormItem
          label="邮箱地址："
          prop="receiveEmail"
          :required="true"
        >
          <Input
            v-model="secondForm.receiveEmail"
            placeholder="请输入邮箱地址"
            style="width: 300px"
          />
        </FormItem>
        <FormItem
          label="备注："
          prop="remark"
        >
          <Input
            v-model="secondForm.remark"
            type="textarea"
            maxlength="80"
            placeholder="请输入备注信息"
            style="width: 300px"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="onSecondCancel">
          取消
        </Button>
        <Button
          type="primary"
          @click="onSecondOk('secondFormValidate')"
        >
          确定
        </Button>
      </div>
    </Modal>

    <Modal
      v-model="modalFrozen"
      :title="`订单${frozenTitle}`"
    >
      <Form
        ref="frozenForm"
        :model="frozenForm"
        :label-width="80"
        :rules="ruleValidate"
      >
        <FormItem
          :label="`${frozenTitle}原因`"
          prop="remark"
        >
          <Input
            v-model="frozenForm.remark"
            type="textarea"
            :rows="4"
            :placeholder="`请输入${frozenTitle}原因`"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modalFrozen = false">
          取消
        </Button>
        <Button
          type="primary"
          @click="frozenOk('frozenForm')"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// 等接口改为通用后，删除该API请求，统一使用未封装axios
import {
  billingEntity,
  taxNumber,
  freeRateList,
  billingOrderList,
  invoiceModelCheck,
  createInvoiceReq,
  queryEnterpriseByname,
  einvoiceOrderFrozen,
  einvoiceOrderUnfrozen,
  querySaleDutyByname,
  exportExcelRecords,
} from '../../api/orderBilling';
import { indBbillingOrderList, indOrderSummary, indInvoiceModelCheck, indparamGrid, getParamById, indCreateInvoiceReq, indexportExcelRecords, indquerySaleDutyByname } from '../../api/independentInvoice';
import { getCookie, getCountTime } from '../../utils/tools';

export default {
  name: 'OrderBillingApi',
  components: {},
  data() {
    return {
      applySubjectId: getCookie('apply-subject-id') || '',
      modalFirst: false,
      modalSecond: false,
      modalFrozen: false,
      frozenType: 'frozen',
      frozenForm: {
        remark: '',
      },
      isRedirect: false,
      applierId: null,
      queryapplySubjectId: null,
      isLoading: false,
      tableLoading: false,
      btnLoading: false,
      searchLoading: false,
      params: {
        startTime: '',
        endTime: '',
      },
      buyDutyNameList: [],
      defaultTime: [],
      BillingArray: [], // 开票主体
      freeRateType: [], // 税率类型
      TaxNumberArray: [], // 税收分类编号
      rateRow: {}, // 当前选择的分类编号对象
      invoiceModel: '', // 是否主体开票
      total: 0,
      showSearch: false, // 店铺是否开启
      tableData: [],
      firstForm: {},
      firstRule: {
        paramId: [
          {
            required: true,
            message: '请选择开票主体',
          },
        ],
        rateId: [
          {
            required: true,
            message: '请选择税收分类编号',
          },
        ],
      },
      ruleValidate: {
        remark: [
          {
            required: true,
            message: '请输入原因',
          },
        ],
      },
      secondForm: {
        buyDutyName: '',
        buyDutyNo: '',
        buyCategory: 0,
        leftAmount: 0,
      },
      secondRule: {
        buyDutyName: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        buyDutyNo: [
          {
            required: true,
            message: '请输入企业税号',
            trigger: 'blur',
          },
        ],
        leftAmount: [
          {
            required: true,
            message: '请输入开票金额',
          },
        ],
        receiveMobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur',
          },
        ],
        receiveEmail: [
          {
            required: true,
            message: '请输入邮箱地址',
            trigger: 'blur',
          },
        ],
      },
      columns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center',
        },
        {
          title: '交易订单号',
          align: 'center',
          width: 250,
          key: 'orderNo',
        },
        {
          title: '订单明细号',
          align: 'center',
          width: 250,
          key: 'orderDetailNo',
        },
        {
          title: '开票主体',
          align: 'center',
          width: 250,
          key: 'saleDutyName',
        },
        {
          title: '身份证号',
          align: 'center',
          width: 160,
          key: 'cardNo',
        },
        {
          title: '团队名称 | 团号',
          align: 'center',
          key: 'city',
          minWidth: 250,
          render(h, params) {
            const { applySubject = '', applySubjectId = '' } = params.row;
            return h(
              'span',
              `${applySubject || '--'} | ${applySubjectId || '--'}`,
            );
          },
        },
        {
          title: '商品名称 | 明细数量',
          align: 'center',
          key: 'city',
          minWidth: 250,
          render(h, params) {
            const { goodsName = '', amount = 0 } = params.row;
            return h('span', `${goodsName} | ${amount}`);
          },
        },
        {
          title: '订单金额',
          align: 'center',
          width: 120,
          key: 'price',
        },
        {
          title: '可开金额',
          align: 'center',
          width: 120,
          key: 'leftAmount',
        },
        {
          title: '状态',
          align: 'center',
          width: 120,
          key: 'invoiceStatus',
          render(h, params) {
            const { invoiceStatus = 10 } = params.row;
            return h(
              'span',
              Number(invoiceStatus) === 40 ? '已冻结' : '未冻结',
            );
          },
        },
        {
          title: '核销时间',
          align: 'center',
          width: 180,
          key: 'finishTime',
        },
      ],
      columns2: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center',
        },
        {
          title: '交易订单号',
          align: 'center',
          width: 250,
          key: 'orderNo',
        },
        {
          title: '订单明细号',
          align: 'center',
          width: 250,
          key: 'orderDetailNo',
        },
        {
          title: '开票主体',
          align: 'center',
          width: 250,
          key: 'saleDutyName',
        },
        {
          title: '团队名称 | 团号',
          align: 'center',
          key: 'city',
          minWidth: 250,
          render(h, params) {
            const { applySubject = '', applySubjectId = '' } = params.row;
            return h(
              'span',
              `${applySubject || '--'} | ${applySubjectId || '--'}`,
            );
          },
        },
        {
          title: '商品名称 | 明细数量',
          align: 'center',
          key: 'city',
          minWidth: 250,
          render(h, params) {
            const { goodsName = '', amount = 0 } = params.row;
            return h('span', `${goodsName} | ${amount}`);
          },
        },
        {
          title: '订单金额',
          align: 'center',
          width: 120,
          key: 'price',
        },
        {
          title: '可开金额',
          align: 'center',
          width: 120,
          key: 'leftAmount',
        },
        {
          title: '核销时间',
          align: 'center',
          width: 180,
          key: 'finishTime',
        },

      ],
      timer: null,
      selectArray: [],
      disabledBuyDutyName: false,
      disabledBuyDutyNo: false,
      saleDutySearchLoading: false,
      saleDutyNameList: [],
      totalLeftAmount: 0,
    };
  },
  computed: {
    selectIds() {
      return this.selectArray.map((item) => item.id);
    },
    frozenTitle() {
      return this.frozenType === 'frozen' ? '冻结' : '解冻';
    },
  },
  watch: {
    selectArray(v) {
      // 获取选中对象数组
      this.secondForm.leftAmount = this.computedTotal();
      this.$emit('handle-select', v);
    },
    selectIds(v) {
      console.log('选中的数组', v);
    },
  },
  created() {
    this.applierId = this.$route.query.applierId || null;
    this.queryapplySubjectId = this.$route.query.applySubjectId || null;
    if (this.$route.query.applySubjectId) {
      this.applySubjectId = this.$route.query.applySubjectId;
      this.isRedirect = true;
    }
  },
  mounted() {
    const { t1, t2 } = getCountTime(7); // 设置默认时间
    this.defaultTime = [t2, t1];
    this.params = {
      startTime: t2,
      endTime: t1,
    };
    this.init({});
    this.getEinvoiceParam(); // 获取开票主体
    this.getFreeRate(); // 获取税率类型
    if (this.$route.query.applySubjectId) {
      this.getTotalPrice();// 获取总金额
    }
  },
  methods: {
    exportExcel() {
      if (this.isRedirect) {
        this.params.applySubjectId = this.applySubjectId;
        if (this.$route.query.applierId) {
          this.params.applierId = this.$route.query.applierId;
        }

        this.params.corpCode = this.$route.query.corpCode;
        indexportExcelRecords(this.params).then(() => {
          this.$Message.success('导出成功');
        });
      } else {
        exportExcelRecords(this.params).then(() => {
          this.$Message.success('导出成功');
        });
      }
    },
    searchRemotesaleDuty(query) {
      const queryTrim = query.trim();
      if (!queryTrim) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.querySaleDutyByname(queryTrim);
      }, 600);
    },
    querySaleDutyByname(query) {
      if (this.isRedirect) {
        indquerySaleDutyByname({ saleDutyName: query }, this.$route.query.corpCode)
          .then((res) => {
            this.saleDutyNameList = this.filterSaleDutySelectList(res.data, query);
            this.saleDutySearchLoading = false;
          })
          .catch((err) => {
            this.saleDutySearchLoading = false;
            this.saleDutyNameList = [
              {
                saleDutyName: query,
              },
            ];
            this.params.saleDutyName = query;
          });
      } else {
        querySaleDutyByname({ saleDutyName: query })
          .then((res) => {
            this.saleDutyNameList = this.filterSaleDutySelectList(res.data, query);
            this.saleDutySearchLoading = false;
          })
          .catch((err) => {
            this.saleDutySearchLoading = false;
            this.saleDutyNameList = [
              {
                saleDutyName: query,
              },
            ];
            this.params.saleDutyName = query;
          });
      }
    },
    filterSaleDutySelectList(data, query) {
      const filterDataList = [];
      data.forEach((item) => {
        if (item.saleDutyName.trim() !== query) {
          filterDataList.push(item);
        }
      });
      return filterDataList;
    },
    onRemoteSaleDutyChange(value) {
      const matchData = this.saleDutyNameList.find(
        (row) => row.saleDutyName.trim() === value.trim(),
      );
      const {
        saleDutyName = '',
        saleDutyNo = '',
      } = matchData;
      this.params.saleDutyName = saleDutyName;
      this.params.saleDutyNo = saleDutyNo;
    },
    init({ page = 1, limit = 10 }) {
      this.params.page = page;
      this.params.limit = limit;
      this.getData();
    },
    search() {
      this.init({});
      if (this.isRedirect) {
        this.getTotalPrice();
      }
    },
    computedTotal() {
      // 计算总开票金额
      let total = 0;
      this.selectArray.forEach((item) => {
        total += item.leftAmount || 0;
      });
      return total.toFixed(2);
    },
    searchRemote(query) {
      const queryTrim = query.trim();
      if (!queryTrim) {
        return;
      }
      if (queryTrim.length < 4) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.queryEnterpriseByname(queryTrim);
      }, 600);
    },
    queryEnterpriseByname(query) {
      // this.searchLoading = true;
      queryEnterpriseByname({ enterpriseName: query })
        .then((res) => {
          this.buyDutyNameList = this.filterSelectList(res.data, query);
          this.searchLoading = false;
        })
        .catch((err) => {
          this.searchLoading = false;
          this.buyDutyNameList = [
            {
              enterpriseName: query,
            },
          ];
          this.secondForm.buyDutyName = query;
        });
    },
    filterSelectList(data, query) {
      const filterDataList = [];
      let isExist = false;
      data.forEach((item) => {
        if (item.enterpriseName.trim() !== query) {
          filterDataList.push(item);
        } else {
          isExist = true;
        }
      });

      if (!isExist) {
        // 未完全匹配出结果，默认设置当前输入项
        filterDataList.unshift({
          enterpriseName: query,
        });
        // this.secondForm.buyDutyName = query;
      }

      return filterDataList;
    },
    onRemoteChange(value) {
      const matchData = this.buyDutyNameList.find(
        (row) => row.enterpriseName.trim() === value.trim(),
      );
      const {
        enterpriseName = '',
        enterpriseCode = '',
        addressTelephone = '',
      } = matchData;
      const [address = '', phone = ''] = addressTelephone.split(' ');
      // buyDutyName buyDutyNo receiveMobile
      this.secondForm.buyDutyName = enterpriseName;
      this.secondForm.buyDutyNo = enterpriseCode;
      this.secondForm.receiveMobile = phone;
    },
    onBuyCategoryChange() {
      if (!this.disabledBuyDutyName) {
        this.secondForm.buyDutyName = '';
        this.buyDutyNameList = [];
      }
    },
    getData() {
      this.tableLoading = true;
      if (this.applySubjectId) {
        this.params.applySubjectId = this.applySubjectId;
      }
      if (this.params.saleDutyNo && !this.params.saleDutyName) {
        delete this.params.saleDutyNo;
      }
      if (this.isRedirect) {
        this.params.applySubjectId = this.applySubjectId;
        if (this.$route.query.applierId) {
          this.params.applierId = this.$route.query.applierId;
        }
        indBbillingOrderList(this.params, this.$route.query.corpCode)
          .then((res) => {
            this.tableData = res.data.rows || [];
            this.total = res.data.total || 0;
            this.setChecked(); // 设置默认勾选项
            this.showSearch = Number((this.tableData[0] || {}).useQuery) === 1;
            this.tableLoading = false;
          })
          .catch((err) => {
            this.$Message.error(err.message || '请求异常');
            this.tableLoading = false;
          });
      } else {
        billingOrderList(this.params)
          .then((res) => {
            this.tableData = res.data.rows || [];
            this.total = res.data.total || 0;
            this.setChecked(); // 设置默认勾选项
            this.showSearch = Number((this.tableData[0] || {}).useQuery) === 1;
            this.tableLoading = false;
          })
          .catch((err) => {
            this.$Message.error(err.message || '请求异常');
            this.tableLoading = false;
          });
      }
    },
    getTotalPrice() {
      if (this.$route.query.applierId) {
        this.params.applierId = this.$route.query.applierId;
      }
      this.params.applySubjectId = this.applySubjectId;
      indOrderSummary(this.params, this.$route.query.corpCode)
        .then((res) => {
          this.totalLeftAmount = res.data && res.data.totalLeftAmount ? res.data.totalLeftAmount : 0;
        })
        .catch((err) => {
          this.$Message.error(err.message || '请求失败');
        });
    },
    setChecked() {
      this.tableData.forEach((item) => {
        item._checked = this.selectIds.indexOf(item.id) > -1;
      });
    },
    onSelection(selection, row) {
      // 选中
      this.selectArray.push(row);
    },
    onSelectAll(selection) {
      // 全选
      selection.forEach((item) => {
        const findRow = this.selectArray.find((row) => row.id === item.id);
        if (!findRow) {
          this.selectArray.push(item);
        }
      });
    },
    onDateChange(date) {
      this.params.startTime = date[0];
      this.params.endTime = date[1];
    },
    onSelectCancel(selection, row) {
      // 删除
      const findIndex = this.selectArray.findIndex(
        (item) => item.id === row.id,
      );
      this.selectArray.splice(findIndex, 1);
    },
    onSelectionChange(selection) {
      // 模拟取消全选
      const ids = this.tableData.map((item) => item.id);
      if (selection.length === 0) {
        ids.forEach((item) => {
          const findIndex = this.selectArray.findIndex(
            (row) => row.id === item,
          );
          if (findIndex > -1) {
            this.selectArray.splice(findIndex, 1);
          }
        });
      }
    },
    filterSaleDutyName() {
      // 判断选中的列表中是否存在相同的主体名称
      const obj = {};
      this.selectArray.forEach((item) => {
        if (item.buyDutyName && !obj[item.buyDutyName]) {
          obj[item.buyDutyName] = item.id;
        }
      });
      return this.selectArray.length >= 1 && Object.keys(obj).length > 1;
    },
    goInvoice() {
      if (this.selectArray.length === 0) {
        this.$Message.warning('至少选择一条数据!');
        return;
      }

      if (this.filterSaleDutyName()) {
        this.$Message.error('请确保所选订单的购方主体名称保持一致！');
        return;
      }

      // 校验弹窗类型
      this.invoiceModelCheck().then((res) => {
        this.invoiceModel = res.invoiceModel || '';
        if (Number(res.invoiceModel) === 0) {
          this.modalFirst = true;
        } else {
          this.modalSecond = true;
        }
      });

      // 设置默认主体名称
      const hasBuyDutyName =
        this.selectArray.find((item) => item.buyDutyName) || {};
      const { buyDutyName = '' } = hasBuyDutyName;
      this.secondForm.buyDutyName = buyDutyName;
      this.disabledBuyDutyName = Boolean(buyDutyName);

      // 设置默认主体税号
      const hasBuyDutyNo =
        this.selectArray.find((item) => item.buyDutyNo) || {};
      const { buyDutyNo = '' } = hasBuyDutyNo;
      this.secondForm.buyDutyNo = buyDutyNo;
      this.disabledBuyDutyNo = Boolean(buyDutyNo);
    },
    frozen() {
      if (this.selectArray.length === 0) {
        this.$Message.warning('至少选择一条数据!');
        return;
      }

      this.modalFrozen = true;
      this.frozenType = 'frozen';
    },
    unFrozen() {
      if (this.selectArray.length === 0) {
        this.$Message.warning('至少选择一条数据!');
        return;
      }

      this.modalFrozen = true;
      this.frozenType = 'unFrozen';
    },
    frozenOk(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.modalFrozen = false;
          this.frozenApi(this.frozenType);
        }
      });
    },
    frozenApi(type) {
      const func =
        type === 'frozen' ? einvoiceOrderFrozen : einvoiceOrderUnfrozen;
      const typeString = type === 'frozen' ? '冻结' : '解冻';
      func({
        idList: this.selectIds,
        ...this.frozenForm,
      })
        .then((res) => {
          if (res.status === 200) {
            this.$Message.success(`${typeString}成功`);
            this.frozenForm.remark = '';
            this.getData();
            this.selectArray = [];
          } else {
            this.$Message.error(res.message || '请求异常');
          }
        })
        .catch((err) => {
          this.$Message.error(err.message || '请求异常');
        });
    },
    invoiceModelCheck() {
      this.btnLoading = true;
      return new Promise((resolve, rejects) => {
        if (this.isRedirect) {
          indInvoiceModelCheck({ idList: this.selectIds }, this.$route.query.corpCode)
            .then((res) => {
              if (res.status === 200) {
                resolve(res.data);
              } else {
                this.$Message.error(res.message || '请求异常');
                rejects(res);
              }
              this.btnLoading = false;
            })
            .catch((err) => {
              this.$Message.error(err.message || '请求异常');
              this.btnLoading = false;
              rejects(err);
            });
        } else {
          invoiceModelCheck({ idList: this.selectIds })
            .then((res) => {
              if (res.status === 200) {
                resolve(res.data);
              } else {
                this.$Message.error(res.message || '请求异常');
                rejects(res);
              }
              this.btnLoading = false;
            })
            .catch((err) => {
              this.$Message.error(err.message || '请求异常');
              this.btnLoading = false;
              rejects(err);
            });
        }
      });
    },
    getEinvoiceParam() {
      // 获取开票主体
      if (this.isRedirect) {
        indparamGrid({
          page: 1,
          limit: 999,
        }, this.$route.query.corpCode).then((res) => {
          this.BillingArray = res.data.rows || [];
        });
      } else {
        billingEntity({
          page: 1,
          limit: 999,
        }).then((res) => {
          this.BillingArray = res.data.rows || [];
        });
      }
    },
    getEinvoiceNumber(id) {
      // 获取税收分类编号
      if (this.isRedirect) {
        getParamById({
          id,
        }, this.$route.query.corpCode).then((res) => {
          this.TaxNumberArray = res.data.rates || [];
        });
      } else {
        taxNumber({
          id,
        }).then((res) => {
          this.TaxNumberArray = res.data.rates || [];
        });
      }
    },
    getFreeRate() {
      freeRateList({}).then((res) => {
        this.freeRateType = res.data;
      });
    },
    getRateType(freeRate) {
      const row = this.freeRateType.find((item) => item.key === freeRate) || {};
      return row.value || '免税';
    },
    onBillingChange(id) {
      this.getEinvoiceNumber(id);
    },
    rateIdChange(id) {
      const row = this.TaxNumberArray.find((item) => item.id === id);
      this.rateRow = row || {};
    },
    onFirstOk(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.modalSecond = true;
        } else {
          this.$Message.error('请完善必填项');
        }
      });
    },
    onFirstCancel() {},
    onSecondOk(name) {
      // 开票
      this.$refs[name].validate((valid) => {
        if (valid) {
          const detailList = this.selectArray.map((item) => {
            return {
              amount:
                this.selectArray.length === 1 // 单订单开票，支持修改金额
                  ? this.secondForm.leftAmount
                  : item.leftAmount,
              detailId: item.id,
            };
          });
          const params = { ...this.firstForm, ...this.secondForm, detailList };
          if (this.isRedirect) {
            indCreateInvoiceReq(params, this.$route.query.corpCode)
              .then((res) => {
                if (res.status === 200) {
                  this.$Message.success('开票成功');
                  this.getData(); // 刷新列表数据
                  this.selectArray = [];
                } else {
                  this.$Message.error(res.message || '请求异常');
                }
              })
              .catch((err) => {
                this.$Message.error(err.message || '请求异常');
              });
          } else {
            createInvoiceReq(params)
              .then((res) => {
                if (res.status === 200) {
                  this.$Message.success('开票成功');
                  this.getData(); // 刷新列表数据
                  this.selectArray = [];
                } else {
                  this.$Message.error(res.message || '请求异常');
                }
              })
              .catch((err) => {
                this.$Message.error(err.message || '请求异常');
              });
          }

          this.modalSecond = false;
        } else {
          this.$Message.error('请完善必填项');
        }
      });
    },
    onSecondCancel() {
      if (this.invoiceModel === 0) {
        this.modalFirst = true;
      }
      this.modalSecond = false;
    },
    onChange(page) {
      const { limit = 10 } = this.params;
      this.init({ page, limit });
    },
    onPageSizeChange(size) {
      this.init({ page: 1, limit: size });
    },
  },
};
</script>
<style>
@import url('./index.css');
</style>



// WEBPACK FOOTER //
// node_modules/@sditest/electronic-invoice-api/src/components/orderBillingApi/index.vue